import { render, staticRenderFns } from "./History.vue?vue&type=template&id=86705ac4"
import script from "./History.vue?vue&type=script&lang=js"
export * from "./History.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86705ac4')) {
      api.createRecord('86705ac4', component.options)
    } else {
      api.reload('86705ac4', component.options)
    }
    module.hot.accept("./History.vue?vue&type=template&id=86705ac4", function () {
      api.rerender('86705ac4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/cardHandling/components/History.vue"
export default component.exports